import React, { useState } from 'react';
import { Layout } from 'antd';
import HeaderContent from './layout/HeaderContent';
import MainContent from './layout/MainContent';
import FooterContent from './layout/FooterContent';
import { makeStyles } from '@material-ui/core/styles';

const { Header, Content, Footer } = Layout;

const useStyles = makeStyles(() => ({
  layout: {
    minHeight: '100vh',
    background: '#fff'
  },
  header: {
    height: 86,
    color: '#fff',
    background: '#fff',
    width: '100%',
    position: 'sticky',
    top: 0,
    zIndex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    boxShadow: '0px 0px 18px rgba(0, 0, 0, 0.1)',
    '@media (max-width: 1260px)': {
      height: '52px !important',
      padding: '0 0 0 12px !important'
    },
  },
  logo: {
    width: 48
  },
  footer: {
    color: '#fff',
    background: '#393535',
    textAlign: 'center',
    '& h3': {
      fontWeight: 'normal',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    '& a': {
      marginLeft: 10,
    },
    '@media (max-width: 1260px)': {
      fontSize: 10,
      padding: '26px 12px',
      '& h3': {
        flexDirection: 'column'
      }
    }
  }
}));

const App: React.FC = () => {
  const classes = useStyles();
  const [menuKey, setMenu] = useState('0');

  return (
    <Layout className={classes.layout}>
      <Header className={classes.header}>
        <HeaderContent menuKey={menuKey} setMenu={setMenu} />
      </Header>
      <Content>
        <MainContent menuKey={menuKey} setMenu={setMenu} />
      </Content>
      <Footer className={classes.footer}>
        <FooterContent />
      </Footer>
    </Layout>
  );
};

export default App;